import { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

// import { useTranslation } from 'react-i18next';
import IzvrseneUsluge from '../IzvrseneUsluge/IzvrseneUsluge';
import UtroseniDelovi from '../UtroseniDelovi/UtroseniDelovi';
import Troskovi from '../Troskovi/Troskovi';
import { TabPanel, a11yProps } from '../../../UI/MuiTab';
import Transport from '../Transport/Transport';
import OpisRadova from '../OpisRadova.jsx/OpisRadova';
import Izvestaji from '../../PregledPustanjaMasine/Izvestaji';
import { OBJEKAT_WORK_REPORTA } from '../../shared/IzvestajRadnogNaloga/useIzvestajRadnogNaloga';

const TabsProvider = ({ idRn, naplacujeSe }) => {
  //   const { t, i18n } = useTranslation();
  const prikaziWorkReportove = localStorage.uniqueUser === 'true';
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (idRn > 0) {
      setValue(0);
    }
  }, [idRn]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              disabled={!(idRn !== 0)}
              label="Izvršene usluge"
              sx={{ textTransform: 'none' }}
              {...a11yProps(0)}
            />
            <Tab
              disabled={!(idRn !== 0)}
              label="Putovanje"
              sx={{ textTransform: 'none' }}
              {...a11yProps(1)}
            />
            <Tab
              disabled={!(idRn !== 0)}
              label="Utrošeni delovi"
              {...a11yProps(2)}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              disabled={!(idRn !== 0)}
              label="Troškovi"
              {...a11yProps(3)}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              disabled={!(idRn !== 0)}
              label="Opis radova"
              {...a11yProps(4)}
              sx={{ textTransform: 'none' }}
            />
            {prikaziWorkReportove && (
              <Tab
                disabled={!(idRn !== 0)}
                label="Work reportovi"
                {...a11yProps(5)}
                sx={{ textTransform: 'none' }}
              />
            )}
          </Tabs>
        </Box>
      </Box>
      <TabPanel disabled value={value} index={0}>
        {idRn !== 0 && <IzvrseneUsluge idRn={idRn} naplacujeSe={naplacujeSe} />}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Transport idRn={idRn} naplacujeSe={naplacujeSe} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UtroseniDelovi idRn={idRn} naplacujeSe={naplacujeSe} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Troskovi idRn={idRn} naplacujeSe={naplacujeSe} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <OpisRadova idRn={idRn} />
      </TabPanel>
      {prikaziWorkReportove && (
        <TabPanel value={value} index={5}>
          {idRn !== 0 && (
            <Izvestaji
              key={idRn}
              idNaloga={idRn}
              objekat={OBJEKAT_WORK_REPORTA}
              evidencijaSlanja
            />
          )}
        </TabPanel>
      )}
    </>
  );
};

export default TabsProvider;
